
import { useAuthStore } from "../../stores";





// const roels = ['SUPERADMIN', 'ADMINISTRADOR', 'DISTRIBUIDOR']
export const useValidarRoles = () => {

    
    const usuario = useAuthStore(state => state.usuario);
    

    const permitirXRol = (...rolesPermitidos) => {
        if(!usuario) return false;
        return rolesPermitidos.includes(usuario?.role);
    };
    
    
    
    

    
    
    
    const admin = ['SUPERADMIN', 'ADMINISTRADOR'];
    const isAdminRol = () => {
        return admin.includes(usuario?.role)
    }



    return {
        permitirXRol,

        isAdminRol,
    }
}
